<template>
  <RegiterVerify />
</template>

<script>
import RegiterVerify from "@/components/register-verify";
export default {
  name: "RegistroVerify",
  components: {RegiterVerify}
};
</script>
